import Layout from "../components/Layout";
import React, {useEffect, useState, useRef} from 'react'
import {useDispatch, useSelector} from 'react-redux';
import {Formik } from 'formik'
import TextField from "../components/TextField";
import axios from 'axios';
import {BASE_URL} from "../utils/commonUrl";
import {ProgressSpinner} from "primereact/progressspinner";
import * as Yup from "yup";
import { Toast } from 'primereact/toast';
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Button} from "primereact/button";
import {FilterMatchMode, FilterOperator} from "primereact/api";
import {InputText} from "primereact/inputtext";

const MatrixLibraryCreate = () => {
    const primeToast = useRef(null)
    const {user} = useSelector((state) => state["auth"]);
    const [isLoading,setIsLoading] = useState(false)
    const [isEnable,setIsEnable] = useState(true)
    const [isRemove,setIsRemove] = useState(false)
    const [userInformation,setUserInformation] = useState([])
    const [matrixTitleList,setMatrixTitleList] = useState([])
    const [userMatrixTitle,setUserMatrixTitle] = useState([])
    const [matrixTitleData, setMatrixTitleData] = useState({
        registerID: user.registerID,
        matrixLibraryID: 0,
        matrixTitle: ""
    });

    const validation = Yup.object({
        matrixTitle: Yup.string().required("This field is required"),
    })

    useEffect(() => {
        initFilters();
        GetMatrixTitles();
    }, [])

    const GetMatrixTitles = () => {
        setIsLoading(true);
        axios.get(BASE_URL + "/api/MatrixLibrary/GetAllMatrixTitle")
            .then(response => {
                setMatrixTitleList(response.data)
                setIsLoading(false);
            })
            .catch(console.error)
    }
    
    const matrixTitleLink = ({matrixLibraryID,matrixTitle}) => (
        <a href="#" style={{textDecoration:"none"}} onClick={() => UpdateMatrixTitle(matrixLibraryID,matrixTitle)} > {matrixTitle}</a>
    )

    const UpdateMatrixTitle = (id,title) =>{
        setMatrixTitleData({
            registerID: user.registerID,
            matrixLibraryID: id,
            matrixTitle: title
        });
    }

    const ClearForm = () =>{
        setMatrixTitleData({
            registerID: user.registerID,
            matrixLibraryID: 0,
            matrixTitle: ""
        });
    }

    const initFilters = () => {
        setFilters({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            'matrixTitle': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
        });
        setGlobalFilterValue('');
    }

    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const onGlobalFilterChange1 = (e) => {
        const value = e.target.value;
        let _filters = {...filters};
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    }

    const clearFilter = () => {
        initFilters();
    }

    const gridHeader = (
        <div className="table-header">
            <div className='d-flex justify-content-between'>
                <div>
                    <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined" onClick={clearFilter}/>
                    <span className="p-input-icon-left"> <i className="pi pi-search"/>
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange1} placeholder="Keyword Search"/>
                </span>
                </div>
            </div>
        </div>
    );
    
    return (<Layout>
        <Toast ref={primeToast}/>
        <div className="card mt-2">
            <div className="card-header d-flex justify-content-between">
                <h6><i class="bi bi-person-plus"></i> Skill Titles</h6>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-6">
                        <DataTable value={matrixTitleList} 
                            header={gridHeader}
                            globalFilterFields={['matrixTitle']}
                            filters={filters} 
                            filterDisplay="menu"
                            resizableColumns
                            showGridlines
                            dataKey="userRoleID"
                            paginator rows={10} first={1}
                                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink">
                                <Column field="matrixLibraryID" header="registerID" hidden={true}/>
                                <Column field='matrixTitle' sortable header="Skill Titles" body={matrixTitleLink} />                     
                            </DataTable>
                    </div>
                    <div className="col-6">
                    <Formik  validationSchema={validation}
        enableReinitialize={true} 
       initialValues={{ registerID: user.registerID, 
        matrixLibraryID: matrixTitleData.matrixLibraryID === 0 ? 0 :matrixTitleData.matrixLibraryID,
        matrixTitle: matrixTitleData.matrixTitle===""?"":matrixTitleData.matrixTitle
       }}
       onSubmit={(values, actions) => {
        const data = JSON.stringify(values, null, 2);
        console.log(data);

        axios.post(BASE_URL + "/api/MatrixLibrary/SaveMatrixTitle", data)
                                .then(response => {
                                    if (response.status === 200) {
                                        GetMatrixTitles();
                                        primeToast.current.show({ 
                                            severity: 'success', 
                                            summary: 'Success', 
                                            detail: 'Title Added Successfully..!', 
                                            life: 3000 });

                                            setMatrixTitleData({
                                                registerID: user.registerID,
                                                matrixLibraryID: 0,
                                                matrixTitle: ""
                                            });
                                    }
                                    else{
                                        primeToast.current.show({
                                            severity: 'error',
                                            summary: 'Error',
                                            detail: 'Title Added Not Failed. Please Contact With MIS Team..!',
                                            life: 3000
                                        });
                                    }
                                }).catch(e => {
                                    primeToast.current.show({
                                        severity: 'error',
                                        summary: 'Error',
                                        detail: 'Title Added Error. Please Contact With MIS Team..!',
                                        life: 3000
                                    });
                                })
       
       }
    }
     >
       {props => (
         <form onSubmit={props.handleSubmit}>
          <div className="row">
            <div className="card-header">
                <h6><i class="bi bi-person-plus"></i> {matrixTitleData.matrixLibraryID > 0? "Update Skill Titles" : "Add Skill Titles"}</h6>
            </div>
            <div className="col-12">
                <TextField label={'Skill Titles'} type="text" name="matrixTitle" 
                onChange={props.handleChange} onBlur={props.handleBlur}
                value={props.values.matrixTitle} placeholder="Skill Titles.."/>
            </div>
          </div>
            <div className="row">
                <div className="col-12">
                {props.errors.name && <div id="feedback">{props.errors.name}</div>} 
                {/* disabled={isEnable=== true? true : false}*/}
                    <button type="submit"
                    className="btn btn-primary">
                    <i class="bi bi-plus-circle"></i> {matrixTitleData.matrixLibraryID > 0? "Update" : "Save"}</button>
                    
                    <button type="button" className="btn btn-success ms-2" onClick={ClearForm}><i class="bi bi-eraser"></i> Clear</button>
                </div>
            </div>
            <TextField label={''} type="hidden" name="registerID"  
            onChange={props.handleChange} 
            onBlur={props.handleBlur} value={props.values.registerID}/>

            <TextField label={''} type="hidden" name="matrixLibraryID"  
            onChange={props.handleChange} 
            onBlur={props.handleBlur} value={props.values.matrixLibraryID}/>
         </form>
       )}
            </Formik>
                    </div>
                </div>
            </div>            
        </div>
    </Layout>)
}

export default MatrixLibraryCreate